import React, { useMemo, useRef, useCallback, useEffect, useState } from "react";
import MainLayout from "../../Layout/mainLayout";
import { useDispatch, useSelector } from "react-redux";
import "./allProjects.css";
// import { ReactComponent as HideList } from "./Icons/List Hide.svg";
// import BackGroundImage from "./Icons/background.png";
import { ReactComponent as LocationPin } from "./Icons/LocationPin.svg";
import { ReactComponent as SearchIcon } from "./Icons/Search.svg";
import {
  getProjectData,
  getProjectList,
} from "../../Redux/Actions/projectActions";
// import { viewCityList } from "../../Redux/Actions/settingsActions";
import { viewAllCity } from "../../Redux/Actions/settingsActions";
import { getCityTotalPrice } from "../../Redux/Actions/propertyActions";
import { viewBuilderList } from "../../Redux/Actions/builderActions";
import { Link } from "react-router-dom";
import { getMeetingList } from "../../Redux/Actions/meetingAction";
import AddVr from "./addVr";
import AddAR from "./addAr";
import AddLandmarks from "./addLandmark";
import { DateToLocale, ToFirstCapital } from "../../Utils/helpers";
import { Skeleton } from "antd";
import VideoModal from "./addVideo.jsx";
import {
  Calendar, MapPin, Award, Building2, Hash, Home, ChevronRight,
  Sparkles, TrendingUp,
  Eye
} from 'lucide-react';

const AllProjects = () => {
  const [addVR, setAddVR] = useState(false);
  const [addAR, setAddAR] = useState(false);
  const [addReel, setAddReel] = useState(false);
  const [foundProject, setFoundProject] = useState({});
  const [addLandmark, setAddLandmark] = useState(false);
  const [tempSearch, setTempSearch] = useState("");
  const [searchQuery, setSearchQuery] = useState("");
  const [debouncedSearch, setDebouncedSearch] = useState("");
  const [selectedProjectId, setSelectedProjectId] = useState(null);
  const [isSearching, setIsSearching] = useState(false);
  const [activeTab, setActiveTab] = useState('overview');

  const { admin } = useSelector((state) => state.admin || {});
  const accessCode = admin?.data?.access_code || [];
  const canAdd = Array.isArray(accessCode) && accessCode.includes('add');
  // const canEdit = Array.isArray(accessCode) && accessCode.includes('edit');

  // const [loading, setLoading] = useState(false);
  const {
    listLoading,
    detailLoading,
  } = useSelector((state) => state.projects || {});


  const dispatch = useDispatch();

  const [selectedCityId, setSelectedCityId] = useState("");

  const { citiesList: allCitiesData } = useSelector((state) => state.city || {});
  const hasFetchedCities = useRef(false);

  useEffect(() => {
    if (!allCitiesData?.data?.length && !hasFetchedCities.current) {
      dispatch(viewAllCity());
      hasFetchedCities.current = true;
    }
  }, [dispatch, allCitiesData?.data?.length]);

  // console.log("DATAT", foundProject?.data?.vr_view_count)
  // const fetchProjects = useCallback(
  //   async (page = 1, limit = 1000, showLoader = true) => {
  //     if (showLoader);
  //     const projectPayload = {
  //       status: ["approved", "published", "unpublished", "sold", "requested"],
  //       page,
  //       limit,
  //       is_deleted: false,
  //       ...(searchQuery ? { filter: searchQuery } : {}),
  //     };
  //     try {
  //       await dispatch(getProjectList(projectPayload, showLoader));
  //     } catch {
  //       if (!showLoader) {
  //         toast.error("Failed to refresh project list");
  //       }
  //     } finally {
  //       if (showLoader);
  //     }
  //   },
  //   [dispatch, searchQuery]
  // );

  useEffect(() => {
    if (!tempSearch) {
      setIsSearching(false);
      setDebouncedSearch("");
      return;
    }

    setIsSearching(true);

    const timer = setTimeout(() => {
      setDebouncedSearch(tempSearch.trim());
      setIsSearching(false);
    }, 500);

    return () => clearTimeout(timer);
  }, [tempSearch]);


  useEffect(() => {
    setSearchQuery(debouncedSearch);
  }, [debouncedSearch]);



  useEffect(() => {
    const payload = {
      status: ["approved", "published", "unpublished", "sold", "requested"],
      page: 1,
      limit: 1000,
      business_type: "fresh",
      is_deleted: false,
    };

    dispatch(getProjectList(payload, true));
    dispatch(viewBuilderList({ page: 1, limit: 1000, is_deleted: false }));
    dispatch(getMeetingList({ page: 1, limit: 1000, is_deleted: false }));
  }, [dispatch]);

  const formatCurrency = (amount, currency) => {
    if (!amount) return '0';

    const numAmount = Number(amount);

    if (currency === 'INR' || currency === '₹') {
      // Indian numbering system: Lakhs and Crores
      if (numAmount >= 10000000) {
        // Crores (1 Crore = 10 Million = 100 Lakhs)
        return `${(numAmount / 10000000).toFixed(2)} Cr`;
      } else if (numAmount >= 100000) {
        // Lakhs (1 Lakh = 100 Thousand)
        return `${(numAmount / 100000).toFixed(2)} L`;
      } else if (numAmount >= 1000) {
        // Thousands
        return `${(numAmount / 1000).toFixed(2)} K`;
      }
      return numAmount.toLocaleString('en-IN');
    } else if (currency === 'AED') {
      // AED: Millions and Thousands
      if (numAmount >= 1000000) {
        return `${(numAmount / 1000000).toFixed(2)} M`;
      } else if (numAmount >= 1000) {
        return `${(numAmount / 1000).toFixed(2)} K`;
      }
      return numAmount.toLocaleString('en-AE');
    } else {
      // Other currencies: Standard K/M/B format
      if (numAmount >= 1000000000) {
        return `${(numAmount / 1000000000).toFixed(2)} B`;
      } else if (numAmount >= 1000000) {
        return `${(numAmount / 1000000).toFixed(2)} M`;
      } else if (numAmount >= 1000) {
        return `${(numAmount / 1000).toFixed(2)} K`;
      }
      return numAmount.toLocaleString();
    }
  };

  // useEffect(() => {
  //   fetchProjects(1, 1000);
  //   const builderPayload = { page: 1, limit: 1000, is_deleted: false };
  //   dispatch(viewBuilderList(builderPayload));
  //   dispatch(getMeetingList(builderPayload));
  // }, [dispatch, fetchProjects]);

  const { projects, project } = useSelector((state) => state.projects || {});
  const { cityTotalPrice, cityTotalPriceLoading } = useSelector((state) => state.properties || {});
  // const { builders } = useSelector((state) => state.builders || {});
  const meetingsState = useSelector((state) => state.meetings || {});
  const meetingsCount = meetingsState.meetings?.data?.count || 0;
  const meetingsCancelledCount =
    meetingsState.meetings?.data?.total_meeting_cancelled || 0;

  const clickedProjectHandler = useCallback((event) => {
    const selectedProject = event.target.closest("li")?.getAttribute("data-id");
    if (!selectedProject || selectedProjectId === selectedProject) return;

    setSelectedProjectId(selectedProject);
    dispatch(getProjectData(selectedProject));
  }, [dispatch, selectedProjectId]);

  const triggerAddVR = () => {
    setAddVR(!addVR);
  };

  const triggerAddAR = () => {
    setAddAR(!addAR);
  };

  // useEffect(() => {
  //   if (searchQuery) {
  //     fetchProjects(1, 1000);
  //   }
  // }, [searchQuery, fetchProjects]);

  const filteredProjects = useMemo(() => {
    if (!Array.isArray(projects?.data)) return [];

    return projects.data.filter((pro) =>
      pro._id === selectedProjectId ||
      pro.project_name?.toLowerCase().includes(searchQuery.toLowerCase()) ||
      pro.street_address?.toLowerCase().includes(searchQuery.toLowerCase())
    );
  }, [projects?.data, searchQuery, selectedProjectId]);

  useEffect(() => {
    if (!selectedProjectId && filteredProjects.length > 0) {
      const firstProject = filteredProjects[0];
      setSelectedProjectId(firstProject._id);
      dispatch(getProjectData(firstProject._id));
    }
  }, [filteredProjects, selectedProjectId, dispatch]);


  const triggerAddReel = () => {
    setAddReel(!addReel);
  };

  useEffect(() => {
    if (selectedCityId) {
      dispatch(getCityTotalPrice({
        city: selectedCityId
      }));
    }
  }, [selectedCityId, dispatch]);

  // useEffect(() => {
  //   const cityPayload = {
  //     page: 1,
  //     limit: 1000,
  //     is_deleted: false
  //   };
  //   dispatch(viewCityList(cityPayload));
  // }, [dispatch]);

  useEffect(() => {
    if (allCitiesData?.data?.length > 0 && !selectedCityId) {
      const mohali = allCitiesData.data.find(city => city._id === "6808dd3def8fb1411ef46efa");
      setSelectedCityId(mohali?._id || allCitiesData.data[0]._id);
    }
  }, [allCitiesData?.data, selectedCityId]);


  const refreshProjectData = () => {
    if (foundProject?.data?._id) {
      dispatch(getProjectData(foundProject.data._id));
    }
  };

  const triggerAddLandmark = () => {
    setAddLandmark(!addLandmark);
  };

  useEffect(() => {
    setFoundProject(project);
  }, [project]);

  const filterHandler = (e) => {
    e.preventDefault();
  };

  const isSearchActive = Boolean(searchQuery);

  const displayProjectCount = isSearchActive
    ? filteredProjects.length
    : projects?.total || 0;

  const statsCards = [
    {
      icon: Building2,
      label: "Total Units",
      value: foundProject?.data?.units?.length || "0",
      color: "blue",
    },
    {
      icon: Eye,
      label: "VR Visits",
      value: foundProject?.data?.vr_view_count || "0",
      color: "purple",
    },
    {
      icon: Award,
      label: "RERA Certified",
      value: foundProject?.data?.rera_id ? "Verified" : "N/A",
      color: "emerald",
      change: "Active"
    },
    {
      icon: TrendingUp,
      label: "Status",
      value: ToFirstCapital(foundProject?.data?.status) || "Active",
      color: "orange",
      change: "Live"
    }
  ];

  return (
    <MainLayout>
      <div
        className="row-span-8 grid-container grid-span-5 gap-10"
        style={{
          gridTemplateColumns: "repeat(9,1fr)",
        }}
      >
        <div
          style={{
            gridColumn: "span 3",
          }}
          className="border-24"
        >
          <div
            style={{
              borderRadius: "20px 20px 0px 0px",
              background: `#070C18`,
            }}
            className="flex-container flex-column flex-center"
          >
            <h3 style={{ color: "white" }}>
              {isSearchActive ? "Search Results" : "Total Projects"}
            </h3>

            {listLoading || isSearching ? (
              <Skeleton.Input
                active
                size="large"
                style={{ width: 120, height: 40 }}
              />
            ) : (
              <h1 className="num_project">
                {displayProjectCount}
                {isSearchActive && (
                  <span style={{ fontSize: "12px", marginLeft: "6px" }}>
                    / {projects?.total || 0}
                  </span>
                )}
              </h1>
            )}

          </div>
          <div className="flex-container align-center flex-justify-around padding-10 bg-white">
            <form
              onSubmit={filterHandler}
              style={{
                border: "1px solid rgba(0, 0, 0, 0.10)",
              }}
              className="flex-container gap-10 align-center flex-justify-between border-10 bg-white width-90 padding-10"
            >
              <input
                type="text"
                placeholder="Search"
                style={{ border: "none", outline: "none" }}
                value={tempSearch}
                onChange={(e) => setTempSearch(e.target.value)}
                onKeyDown={(e) => {
                  if (e.key === "Enter") {
                    e.preventDefault();
                    filterHandler(e);
                  }
                }}
              />
              <button
                type="submit"
                style={{
                  background: "transparent",
                  border: "none",
                  cursor: "pointer",
                }}
              >
                <SearchIcon />
              </button>
            </form>

            {/* <HideList /> */}
          </div>
          <div
            className="scroll-invisible bg-white overflowy-auto"
            style={{
              maxHeight: "300px",
              borderRadius: "0px 0px 20px 20px",
            }}
          >
            {listLoading || isSearching ? (
              <div style={{ padding: "10px" }} >
                {
                  [1, 2, 3, 4].map((item) => (
                    <div
                      key={item}
                      style={{
                        display: "flex",
                        gap: "10px",
                        marginBottom: "15px",
                        alignItems: "center",
                      }}
                    >
                      <Skeleton.Avatar active size={70} shape="circle" />
                      <Skeleton
                        active
                        title={{ width: "80%" }}
                        paragraph={{ rows: 1, width: "90%" }}
                      />
                    </div>
                  ))
                }
              </div>
            ) : filteredProjects.length > 0 ? (
              filteredProjects.map((pro) => (
                <ul
                  className={`list-item ${selectedProjectId === pro._id ? "active-project" : ""}`}
                  onClick={clickedProjectHandler}
                  key={pro._id}
                >
                  <img
                    src={
                      pro?.cover_photo
                        ? pro.cover_photo
                        : require("../../Global Icons/AlternatePropertyImage.png")
                    }
                    width={70}
                    height={70}
                    loading="lazy"
                    style={{
                      marginLeft: "5px",
                      border: "1px solid black",
                      borderRadius: "50px",
                    }}
                    alt="Project"
                  />
                  <div style={{ width: "100%" }}>
                    <li
                      data-id={pro._id}
                      style={{
                        listStyle: "none",
                      }}
                      className="width-100 padding-10"
                    >
                      <h3 className="li_h3">{pro.project_name || "No Data"}</h3>
                      <span className="flex-container align-center margin-h-10">
                        <div className="flex-container gap-10">
                          <LocationPin style={{ background: "white" }} />
                          <p
                            className="li_p margin-0"
                            style={{
                              padding: 0,
                            }}
                          >
                            {pro?.street_address?.replace(/\s+/g, " ").trim() ||
                              "No Data"}
                          </p>
                        </div>
                      </span>
                    </li>
                  </div>
                </ul>
              ))
            ) : (
              <p style={{ padding: "10px", textAlign: "center" }}>No Project Found</p>
            )}
          </div>
          {/* All Project Price Section */}
          <div className="stunning-section-wrapper">
            <div className="stunning-section-header">
              <h2 className="stunning-section-title">All Project Price</h2>
            </div>

            <div className="stunning-price-grid">
              {/* City Selector Card */}
              <div className="stunning-price-card stunning-city-selector">
                <div className="stunning-card-header">
                  <MapPin className="stunning-card-icon " />
                  <label className="stunning-card-label">Select City</label>
                </div>
                <select
                  value={selectedCityId}
                  onChange={(e) => setSelectedCityId(e.target.value)}
                  disabled={cityTotalPriceLoading}
                  className="stunning-select"
                >
                  {Array.isArray(allCitiesData?.data) ? allCitiesData.data.map((city) => (
                    <option key={city._id} value={city._id}>
                      {city.city_name}
                    </option>
                  )) : (
                    <option value="">Loading cities...</option>
                  )}
                </select>
              </div>

              {/* Total Value Card */}
              <div className="stunning-price-card stunning-value-card">
                <div className="stunning-card-bg stunning-card-bg-emerald"></div>
                <div className="stunning-price-content">
                  <div className="stunning-price-header">
                    <div className="stunning-price-icon-wrapper stunning-icon-emerald">
                      <TrendingUp className="stunning-price-icon" />
                    </div>
                    <span className="stunning-price-label">
                      {cityTotalPriceLoading ? "Loading..." : "Total Value"}
                    </span>
                  </div>
                  <div className="stunning-price-value">
                    {cityTotalPriceLoading ? (
                      <Skeleton.Input active size="large" style={{ width: 150 }} />
                    ) : (
                      <>
                        {cityTotalPrice?.currency || "₹"}{" "}
                        {formatCurrency(
                          cityTotalPrice?.total_price,
                          cityTotalPrice?.currency || 'INR'
                        )}
                      </>
                    )}
                  </div>
                </div>
              </div>

              <div style={{ display: "flex", justifyContent: "space-around", width: "100%" }}>
                {/* Properties Card */}
                <div className="stunning-price-card stunning-properties-card" style={{ width: "35%" }}>
                  <div className="stunning-card-bg stunning-card-bg-blue"></div>
                  <div className="stunning-price-content">
                    <div className="stunning-price-header">
                      <div className="stunning-price-icon-wrapper stunning-icon-blue">
                        <Building2 className="stunning-price-icon" />
                      </div>
                      <span className="stunning-price-label">Properties</span>
                    </div>
                    <div className="stunning-price-value">
                      {cityTotalPriceLoading ? (
                        <Skeleton.Input active size="small" style={{ width: 80 }} />
                      ) : (
                        cityTotalPrice?.property_count || 0
                      )}
                    </div>
                  </div>
                </div>

                {/* City Name Card */}
                <div className="stunning-price-card stunning-city-card" style={{ width: "38%" }}>
                  <div className="stunning-card-bg stunning-card-bg-purple"></div>
                  <div className="stunning-price-content">
                    <div className="stunning-price-header">
                      <div className="stunning-price-icon-wrapper stunning-icon-purple">
                        <MapPin className="stunning-price-icon" />
                      </div>
                      <span className="stunning-price-label">City</span>
                    </div>
                    <div className="stunning-price-value stunning-city-name">
                      {cityTotalPriceLoading ? (
                        <Skeleton.Input active size="small" style={{ width: 120 }} />
                      ) : (
                        cityTotalPrice?.city_name || "Loading..."
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div style={{ gridColumn: "span 6" }}>
          {detailLoading ? (
            <Skeleton active paragraph={{ rows: 12 }} />
          ) : (
            <div className="stunning-project-wrapper">
              {/* Glassmorphism Header */}
              <div className="stunning-header-wrapper">
                <div className="stunning-header-overlay"></div>
                <div className="stunning-header-content">
                  <div className="stunning-header-main">
                    <div className="stunning-header-left">
                      <div className="stunning-icon-wrapper">
                        <div className="stunning-icon-blur"></div>
                        <div className="stunning-icon-container">
                          <Building2 className="stunning-icon" />
                        </div>
                      </div>
                      <div className="stunning-header-info">
                        <div className="stunning-header-title-row">
                          <h1 className="stunning-project-title">
                            {foundProject?.data?.project_name || "Project Name"}
                          </h1>
                        </div>
                        <div className="stunning-header-meta">
                          <div className="stunning-meta-item">
                            <MapPin className="stunning-meta-icon" />
                            <span className="stunning-meta-text">
                              {(foundProject?.data?.street_address || "").split(',')[0] || "Location"}
                            </span>
                          </div>
                          <div className="stunning-meta-dot"></div>
                          <div className="stunning-meta-item">
                            <Sparkles className="stunning-meta-icon" />
                            <span className="stunning-meta-text">Luxury Living</span>
                          </div>
                        </div>
                      </div>
                    </div>
                    <Link to="/manage_projects/list" className="stunning-link">
                      <button className="stunning-header-button">
                        <span className="stunning-button-content">
                          View All Projects
                          <ChevronRight className="stunning-chevron" />
                        </span>
                      </button>
                    </Link>
                  </div>
                </div>
              </div>

              {/* Stats Cards */}
              <div className="stunning-stats-grid">
                {statsCards.map((stat, idx) => (
                  <div key={idx} className="stunning-stat-card">
                    <div className={`stunning-stat-bg stunning-stat-bg-${stat.color}`}></div>
                    <div className="stunning-stat-content">
                      <div className={`stunning-stat-icon-wrapper stunning-stat-icon-${stat.color}`}>
                        <stat.icon className="stunning-stat-icon" />
                      </div>
                      <div className="stunning-stat-label">{stat.label}</div>
                      <div className="stunning-stat-footer">
                        <div className="stunning-stat-value">{stat.value}</div>
                        {stat.change && (
                          <div className="stunning-stat-change">
                            {stat.change}
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                ))}
              </div>

              {/* Main Content */}
              <div className="stunning-main-grid">
                {/* Left Section */}
                <div className="stunning-form-section">
                  {/* Tabs */}
                  <div className="stunning-tabs-wrapper">
                    <div className="stunning-tabs-container">
                      {['overview'].map((tab) => (
                        <button
                          key={tab}
                          onClick={() => setActiveTab(tab)}
                          className={`stunning-tab ${activeTab === tab ? 'stunning-tab-active' : ''}`}
                        >
                          {tab.charAt(0).toUpperCase() + tab.slice(1)}
                        </button>
                      ))}
                    </div>
                  </div>

                  {/* Form Fields */}
                  <div className="stunning-form-content">
                    <div className="stunning-form-grid">
                      {/* Brand Name */}
                      <div className="stunning-field">
                        <div className="stunning-field-label">
                          <Award className="stunning-field-icon stunning-icon-indigo" />
                          <label className="stunning-label-text">Builder Name</label>
                        </div>
                        <input
                          disabled
                          value={foundProject?.data?.builder?.brand_name || "No Name"}
                          className="stunning-input stunning-input-gray"
                        />
                      </div>

                      {/* RERA ID */}
                      <div className="stunning-field">
                        <div className="stunning-field-label">
                          <Hash className="stunning-field-icon " style={{ color: "indigo" }} />
                          <label className="stunning-label-text">RERA ID</label>
                        </div>
                        <input
                          disabled
                          value={foundProject?.data?.rera_id || "No RERA ID"}
                          className="stunning-input stunning-input-purple"
                        />
                      </div>

                      {/* Project Status */}
                      <div className="stunning-field">
                        <div className="stunning-field-label">
                          <TrendingUp className="stunning-field-icon" style={{ color: "green" }} />
                          <label className="stunning-label-text">Project Status</label>
                        </div>
                        <div className="stunning-input stunning-input-emerald stunning-status-input">
                          <span className="stunning-status-text">
                            {ToFirstCapital(foundProject?.data?.status) || "Active"}
                          </span>
                          <span className="stunning-pulse-dot"></span>
                        </div>
                      </div>

                      {/* Project ID */}
                      <div className="stunning-field">
                        <div className="stunning-field-label">
                          <Hash className="stunning-field-icon" style={{ color: "blue" }} />
                          <label className="stunning-label-text">Project ID</label>
                        </div>
                        <input
                          disabled
                          value={foundProject?.data?.project_id || "No Project Id"}
                          className="stunning-input stunning-input-blue"
                        />
                      </div>

                      {/* Construction Status */}
                      <div className="stunning-field">
                        <div className="stunning-field-label">
                          <Building2 className="stunning-field-icon stunning-icon-orange" />
                          <label className="stunning-label-text">Construction Status</label>
                        </div>
                        <input
                          disabled
                          value={foundProject?.data?.construction_status || "No Status"}
                          className="stunning-input stunning-input-orange"
                        />
                      </div>

                      {/* Possession Date */}
                      <div className="stunning-field">
                        <div className="stunning-field-label">
                          <Calendar className="stunning-field-icon stunning-icon-cyan" />
                          <label className="stunning-label-text">Possession Date</label>
                        </div>
                        <input
                          disabled
                          value={DateToLocale(foundProject?.data?.possesion_date)}
                          className="stunning-input stunning-input-cyan"
                        />
                      </div>

                      {/* Phase - Full Width */}
                      {/* <div className="stunning-field stunning-field-full">
                        <div className="stunning-field-label">
                          <Layers className="stunning-field-icon stunning-icon-indigo" />
                          <label className="stunning-label-text">Development Phases</label>
                        </div>
                        <div className="stunning-phases-grid">
                          {foundProject?.data?.phases?.map((phase, idx) => (
                            <div key={idx} className="stunning-phase-badge">
                              {phase.name}
                            </div>
                          ))}
                        </div>
                      </div> */}

                      {/* Location - Full Width */}
                      <div className="stunning-field stunning-field-full">
                        <div className="stunning-field-label">
                          <MapPin className="stunning-field-icon stunning-icon-red" />
                          <label className="stunning-label-text">Project Location</label>
                        </div>
                        <div className="stunning-input stunning-input-red" style={{ width: "91.5%" }}>
                          {foundProject?.data?.street_address?.trim() || "No Data"}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                {/* Right Section */}
                <div className="stunning-sidebar">
                  {/* Action Buttons */}
                  <div className="stunning-card">
                    <h3 className="stunning-card-title">Quick Actions</h3>
                    <div className="stunning-actions-list">
                      <button
                        onClick={triggerAddVR}
                        disabled={!canAdd}
                        className={`stunning-action-btn stunning-btn-indigo ${!canAdd ? 'stunning-btn-disabled' : ''}`}
                      >
                        Add VR
                      </button>
                      <button
                        onClick={triggerAddAR}
                        disabled={!canAdd}
                        className={`stunning-action-btn stunning-btn-indigo ${!canAdd ? 'stunning-btn-disabled' : ''}`}
                      >
                        Add AR
                      </button>
                      <button
                        onClick={triggerAddReel}
                        disabled={!canAdd}
                        className={`stunning-action-btn stunning-btn-pink ${!canAdd ? 'stunning-btn-disabled' : ''}`}
                      >
                        Add Reel
                      </button>
                      <button
                        onClick={triggerAddLandmark}
                        disabled={!canAdd}
                        className={`stunning-action-btn stunning-btn-green ${!canAdd ? 'stunning-btn-disabled' : ''}`}
                      >
                        Add Landmark
                      </button>
                    </div>
                  </div>

                  <div className="stunning-card stunning-summary-card">
                    <h3 className="stunning-card-title stunning-summary-title">
                      <Home className="stunning-card-icon" style={{ marginTop: "6px" }} />
                      Unit Summary
                    </h3>
                    <div className="stunning-summary-list">
                      <div className="stunning-summary-item">
                        <span className="stunning-summary-label">Total Units</span>
                        <span className="stunning-summary-value">
                          {foundProject?.data?.units?.length || "0"}
                        </span>
                      </div>
                      {/* <div className="stunning-summary-item">
                        <span className="stunning-summary-label">VR Visits</span>
                        <span className="stunning-summary-value">
                          {foundProject?.data?.vr_view_count || "0"}
                        </span>
                      </div> */}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )}

          <div className="flex-container flex-justify-between align-center padding-10" style={{ width: "94.5%" }}>
            <h2 className="margin-0">Meetings</h2>
            <Link
              to="/meeting"
              className="margin-0"
              style={{ textDecoration: "none", color: "inherit" }}
            >
              <h4 className="margin-0">View All</h4>
            </Link>
          </div>
          <div className="flex-container flex-column gap-10" style={{ display: "flex", flexDirection: "row", justifyContent: "space-around", width: "97%" }}>
            <div className="list_meetings">
              <h2 style={{ marginTop: "8px" }}>Total Meetings</h2>
              <div className="flex-container flex-justify-between align-center">
                <h1 className="margin-0">{meetingsCount}</h1>
              </div>
            </div>
            <div className="list_meetings">
              <h2 style={{ marginTop: "8px" }}>Cancel Meetings</h2>
              <div className="flex-container flex-justify-between align-center">
                <h1 className="margin-0">{meetingsCancelledCount}</h1>
              </div>
            </div>
          </div>
          {/* Modals remain the same */}
          {addReel && (
            <div onClick={() => setAddReel(false)}>
              <div className="modal-content" onClick={(e) => e.stopPropagation()}>
                {project && (
                  <VideoModal
                    vrData={project}
                    onVrRemoved={refreshProjectData}
                    onClose={() => setAddReel(false)}
                  />
                )}
              </div>
            </div>
          )}
          {addVR && (
            <div className="modal-overlay" onClick={() => setAddVR(false)}>
              <div style={{ width: "42%" }} onClick={(e) => e.stopPropagation()}>
                {project && (
                  <AddVr
                    vrData={project}
                    onVrRemoved={refreshProjectData}
                    onClose={() => setAddVR(false)}
                  />
                )}
              </div>
            </div>
          )}
          {addAR && (
            <div className="modal-overlay" onClick={() => setAddAR(false)}>
              <div style={{ width: "42%" }} onClick={(e) => e.stopPropagation()}>
                {project && (
                  <AddAR
                    arData={project}
                    onArRemoved={refreshProjectData}
                    onClose={() => setAddAR(false)}
                  />
                )}
              </div>
            </div>
          )}
          {addLandmark && (
            <div className="modal-overlay" onClick={() => setAddLandmark(false)}>
              <div onClick={(e) => e.stopPropagation()} style={{ width: "35%", background: "white", height: "90%", borderRadius: "20px" }}>
                {project && (
                  <AddLandmarks
                    landmarkData={project}
                    onClose={() => setAddLandmark(false)}
                  />
                )}
              </div>
            </div>
          )}
        </div>
      </div>
    </MainLayout >
  );
};

export default AllProjects;
